export default "__VITE_ASSET__623c5199__"